import { render, staticRenderFns } from "./DisplayValidationCollector.vue?vue&type=template&id=2ce06612&"
import script from "./DisplayValidationCollector.vue?vue&type=script&lang=ts&"
export * from "./DisplayValidationCollector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../FastFailureFeedback.Web.MachineRegistration/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Agent-002\\_work\\9\\s\\Source\\FastFailureFeedback\\FastFailureFeedback.Web.MachineRegistration\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce06612')) {
      api.createRecord('2ce06612', component.options)
    } else {
      api.reload('2ce06612', component.options)
    }
    module.hot.accept("./DisplayValidationCollector.vue?vue&type=template&id=2ce06612&", function () {
      api.rerender('2ce06612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "FastFailureFeedback.Web.Common/Typescript/vuejs/components/DisplayValidationCollector.vue"
export default component.exports